import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-app-settings-form',
	templateUrl: './app-settings-form.component.html',
	styleUrls: ['./app-settings-form.component.scss']
})
export class AppSettingsFormComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}
